import {logger} from '@utils';
import {SagaIterator} from 'redux-saga';
import * as ScheduleWebsocket from './schedule.websocket';
import {put} from "redux-saga/effects";
import * as UserActions from "@services/user/user.actions";

export function* createSchedule(action: any): SagaIterator {
  try {
    ScheduleWebsocket.createSchedule(action.payload);
  } catch (error) {
    logger.info(error);
  }
}

export function* changeScheduleName(action: any): SagaIterator {
  try {
    ScheduleWebsocket.changeScheduleName(action.payload);
  } catch (error) {
    logger.info(error);
  }
}

export function* changeScheduleSchool(action: any): SagaIterator {
  try {
    ScheduleWebsocket.changeScheduleSchool(action.payload);
  } catch (error) {
    logger.info(error);
  }
}



// WEBPACK FOOTER //
// ./src/services/schedule/schedule.saga.ts